module.exports = __webpack_public_path__ + "static/media/nynfc_bg2.7247ea80.jpg";